import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonMenuToggle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from '@ubie/core';

@Component({
  selector: 'app-header',
  imports: [
    IonButton,
    IonButtons,
    IonIcon,
    TranslatePipe,
    IonHeader,
    IonToolbar,
    IonMenuToggle,
  ],
  providers: [Router],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  onLogout(): void {
    setTimeout(() => {
      this.authService.logout();
      this.router.navigateByUrl('/login');
    }, 100);
  }

  onHelpClicked(): void {
    this.router.navigateByUrl('/guide');
  }

  onAccountClicked(): void {
    this.router.navigateByUrl('/account');
  }
}
